/**
 * Loot: crates on the deck, coins inside them, health packs in the centre.
 *
 * The Brawl Stars staple — power cubes in boxes, dropped by the dead, health in
 * the middle — in the market's own words:
 *
 *   CRATE     a lockbox on the floor. Break it and it pays out one COIN.
 *   COIN     a permanent stake: +COIN_DAMAGE_PCT% damage per coin held, up
 *             to COIN_CAP. An eliminated player's holding drops where they
 *             fell, so a kill is an acquisition.
 *   HEALTH PACK  a heal. Declared only near the zone centre (GAME-DESIGN §2:
 *             "Health pickups — center of the arena only. Contested by
 *             design"), because health on the periphery subsidises hiding.
 *
 * These numbers live HERE rather than in the sim for the same reason the dash
 * does (see `DASH_COOLDOWN_MS` in wire.ts): the sim resolves them, but the HUD
 * and the character select quote them, and neither may retype a number the sim
 * owns.
 *
 * Every loot decision is the sim's. No message lets a client claim a pickup —
 * v1's `collect` was exactly that message, and it was a way to take money.
 */
/** Damage bonus per coin held, in percent. Applies to every hit a player deals. */
export const COIN_DAMAGE_PCT = 6;
/**
 * Most coins one player can hold.
 *
 * Priced against the TTK pillar: at the cap Monolith's 55 ultimate lands for
 * 71.5 — still not a one-shot on 80-HP Volt, which is the line GAME-DESIGN §4
 * cut `damage_amp` for crossing. Raise this and re-check that line first.
 */
export const COIN_CAP = 5;
/** HP a health pack restores. Never past max health. */
export const HEALTH_PACK_HEAL = 30;
/** Hit points on a crate. Two or three basics from any character in the roster. */
export const CRATE_HEALTH = 60;
/** The multiplier a holding of `coins` puts on outgoing damage. */
export function coinDamageMultiplier(coins) {
    const held = Math.max(0, Math.min(COIN_CAP, Math.trunc(coins)));
    return 1 + (held * COIN_DAMAGE_PCT) / 100;
}
//# sourceMappingURL=loot.js.map